import React from 'react'

const LeafIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="leafGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(120, 220, 100, 1)" />
          <stop offset="100%" stopColor="rgba(80, 180, 60, 1)" />
        </linearGradient>
        <filter id="leafGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Leaf shape */}
      <path 
        d="M20 12c0-5-4-9-9-9s-9 4-9 9c0 3 1.5 5.5 4 7 0 0 2-1 5-1s5 1 5 1c2.5-1.5 4-4 4-7z"
        fill="url(#leafGradient)"
        filter="url(#leafGlow)"
      />
      
      {/* Leaf vein */}
      <path 
        d="M11 3v16"
        stroke="rgba(255, 255, 255, 0.3)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      
      {/* Side veins */}
      <path 
        d="M11 7c-2 1-3 2-4 3M11 11c-1.5 0.5-2.5 1-3.5 2M11 15c-1 0.5-2 1-3 1.5"
        stroke="rgba(255, 255, 255, 0.2)"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default LeafIcon
